import { render, staticRenderFns } from "./vanhenevat-katseluoikeudet-card.vue?vue&type=template&id=7a21baf0&scoped=true&"
import script from "./vanhenevat-katseluoikeudet-card.vue?vue&type=script&lang=ts&"
export * from "./vanhenevat-katseluoikeudet-card.vue?vue&type=script&lang=ts&"
import style0 from "./vanhenevat-katseluoikeudet-card.vue?vue&type=style&index=0&id=7a21baf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21baf0",
  null
  
)

export default component.exports